module.exports = __webpack_public_path__ + "assets/0103_IFOK_WIM_MARKER_blue_usecase_je.a49faea6.svg";